import { darken, Typography, Grid, Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { EarthPlaneIcon } from "../../../../assets/icons";
import { PendingApprovalsSummaryDTO } from "../../../../models/pending-approvals/pending-approvals-summary-dto";
import IconAndTitleContainer from "../../reusable-widget-link-components/IconAndTitleContainer/IconAndTitleContainer";

const MyClientTeamPendingExpenseClaimsLink = ({
  customSummary,
  loading,
}: {
  customSummary: PendingApprovalsSummaryDTO;
  loading: boolean;
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.my_client_team_pending_approvals";

  return loading ? (
    <Grid style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Skeleton
        variant="rounded"
        width={"100px"}
      />
    </Grid>
  ) : customSummary.expenseClaims > 0 ? (
    <IconAndTitleContainer
      title={`${t(`${tRP}.expense_claims`)}`}
      Icon={EarthPlaneIcon}
      loading={loading}
      endAdornment={
        !loading ? (
          <Typography
            variant="h5"
            style={{ color: theme.palette.text.primary }}
          >
            {customSummary.expenseClaims ?? 0}
          </Typography>
        ) : (
          <></>
        )
      }
      titleStyle={{
        color: darken(theme.palette.text.secondary, 0.15),
      }}
      customStyle={{
        width: "100%",
        justifyContent: "center",
        gap: "30px",
      }}
    />
  ) : (
    <></>
  );
};
export default MyClientTeamPendingExpenseClaimsLink;
